
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assessments/[...all]",
      function () {
        return require("private-next-pages/assessments/[...all].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assessments/[...all]"])
      });
    }
  